import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import CustomersPage from "@/pages/CustomersPage";
import AudiencesPage from "@/pages/AudiencesPage";
import AudienceBuilder from "@/pages/AudienceBuilder";
import EmailCampaignsPage from "@/pages/EmailCampaignsPage";
import EmailCampaignNew from "@/pages/EmailCampaignNew";
import WhatsAppPage from "@/pages/WhatsAppPage";
import TemplatesPage from "@/pages/TemplatesPage";
import TeamPage from "@/pages/TeamPage";
import SettingsPage from "@/pages/SettingsPage";
import UnsubscribePage from "@/pages/UnsubscribePage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  if (user === false) return <Navigate to="/auth" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/unsubscribe/:customerId" element={<UnsubscribePage />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/audiences" element={<AudiencesPage />} />
            <Route path="/audiences/new" element={<AudienceBuilder />} />
            <Route path="/audiences/:audienceId/edit" element={<AudienceBuilder />} />
            <Route path="/email-campaigns" element={<EmailCampaignsPage />} />
            <Route path="/email-campaigns/new" element={<EmailCampaignNew />} />
            <Route path="/whatsapp-campaigns" element={<WhatsAppPage />} />
            <Route path="/templates" element={<TemplatesPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors theme="dark" />
    </AuthProvider>
  );
}

export default App;
